import { render, staticRenderFns } from "./Kumpulan.vue?vue&type=template&id=c5c8f536"
import script from "./Kumpulan.vue?vue&type=script&lang=js"
export * from "./Kumpulan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports